import { ReactElement, useEffect } from "react";
import { useAuthenticator } from "@aws-amplify/ui-react";
import { Navigate, useNavigate } from "react-router-dom";
import LoadingOverlay from "../../_core/components/LoadingOverlay";
import { useAuthSession, useHubUserExist } from "../hooks";

interface PrivateRouteProps {
  children: ReactElement<any, any> | null;
}

export const PrivateRoute = ({ children }: PrivateRouteProps): JSX.Element => {
  const navigate = useNavigate();
  const { authStatus } = useAuthenticator((context: any) => [context.authStatus]);

  const { data: session, isFetching: sessionFetching } = useAuthSession();
  const hasValidIdentityUser = Boolean(session);


  const { data: doesHubUserExist, isFetching: hubUserExistenceFetching } = useHubUserExist({
    enabled: hasValidIdentityUser,
  });

  // Login
  useEffect(() => {
    if (!sessionFetching && !hasValidIdentityUser) {
      navigate("/login");
    }
  }, [hasValidIdentityUser, sessionFetching, navigate]);

  // Redirect to the `no-user` page if we don't have a user in Hub
  useEffect(() => {
    if (hasValidIdentityUser && !hubUserExistenceFetching && !doesHubUserExist) {
      setTimeout(() => navigate("/no-user", { replace: true }));
    }
  }, [hasValidIdentityUser, hubUserExistenceFetching, doesHubUserExist, navigate]);

  if (authStatus !== "authenticated" && hasValidIdentityUser) {
    return <Navigate to="/login" />;
  }

  if (doesHubUserExist) {
    return children || <div />;
  }

  return <LoadingOverlay />;
};
